import { screen } from '@/router/screenRoutes';

export default [
  // routes
  {
    ...screen('corban-screening'),
    component: () => import('@/views/CorbanScreening.vue'),
  },
  {
    ...screen('corban-screening-new'),
    component: () => import('@/views/CorbanScreeningNew.vue'),
  },
  {
    ...screen('corban-screening-details'),
    component: () => import('@/views/CorbanScreeningDetails.vue'),
  },
];
